/** 统一状态展示：label + Element Tag type */
const PRESETS = {
  enable: {
    0: { label: '启用', type: 'success' },
    1: { label: '停用', type: 'info' },
    true: { label: '启用', type: 'success' },
    false: { label: '停用', type: 'info' }
  },
  org: {
    0: { label: '正常', type: 'success' },
    1: { label: '停用', type: 'danger' }
  },
  online: {
    online: { label: '在线', type: 'success' },
    offline: { label: '离线', type: 'info' },
    alarm: { label: '告警', type: 'danger' }
  },
  alarmStatus: {
    pending: { label: '待处理', type: 'danger' },
    active: { label: '待处理', type: 'danger' },
    processing: { label: '处理中', type: 'primary' },
    resolved: { label: '已处理', type: 'success' },
    shielded: { label: '已屏蔽', type: 'info' }
  },
  alarmLevel: {
    critical: { label: '紧急', type: 'danger' },
    warning: { label: '重要', type: 'warning' },
    normal: { label: '一般', type: 'warning' },
    info: { label: '提示', type: 'info' },
    high: { label: '高', type: 'danger' },
    medium: { label: '中', type: 'warning' },
    low: { label: '低', type: 'info' }
  },
  card: {
    active: { label: '已激活', type: 'success' },
    inactive: { label: '未激活', type: 'info' },
    expired: { label: '已过期', type: 'danger' }
  },
  ruleEnabled: {
    0: { label: '启用', type: 'success' },
    1: { label: '停用', type: 'info' }
  },
  oper: {
    0: { label: '成功', type: 'success' },
    1: { label: '失败', type: 'danger' }
  },
  backup: {
    success: { label: '成功', type: 'success' },
    failed: { label: '失败', type: 'danger' },
    running: { label: '进行中', type: 'warning' }
  },
  comm: {
    normal: { label: '正常', type: 'success' },
    abnormal: { label: '异常', type: 'danger' },
    timeout: { label: '超时', type: 'warning' }
  },
  direction: {
    up: { label: '接收', type: 'primary' },
    down: { label: '发送', type: 'warning' }
  },
  reportRecord: {
    normal: { label: '正常', type: 'success' },
    abnormal: { label: '异常', type: 'danger' },
    offline: { label: '离线', type: 'info' },
    warning: { label: '预警', type: 'warning' }
  }
}

export function resolveStatus(kind, value) {
  if (value === null || value === undefined || value === '') {
    return { label: '-', type: 'info' }
  }
  const preset = PRESETS[kind]
  if (!preset) return { label: String(value), type: 'info' }
  const key = typeof value === 'number' ? value : String(value)
  const hit = preset[key] || preset[String(value).toLowerCase()]
  return hit || { label: String(value), type: 'info' }
}

export default PRESETS
